var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.592 16.0217C13.281 16.0217 16.434 16.5807 16.434 18.8137C16.434 21.0467 13.302 21.6217 9.592 21.6217C5.902 21.6217 2.75 21.0677 2.75 18.8337C2.75 16.5997 5.881 16.0217 9.592 16.0217Z",
    stroke: "#CBCBCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59199 12.8347C7.16999 12.8347 5.20599 10.8717 5.20599 8.44974C5.20599 6.02774 7.16999 4.06474 9.59199 4.06474C12.013 4.06474 13.977 6.02774 13.977 8.44974C13.986 10.8627 12.036 12.8257 9.62299 12.8347H9.59199Z",
    stroke: "#CBCBCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4836 11.6965C18.0846 11.4715 19.3176 10.0975 19.3206 8.43454C19.3206 6.79554 18.1256 5.43554 16.5586 5.17854",
    stroke: "#CBCBCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5959 15.5471C20.1469 15.7781 21.2299 16.3221 21.2299 17.4421C21.2299 18.2131 20.7199 18.7131 19.8959 19.0261",
    stroke: "#CBCBCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/Course.c2290f7bca8a4e3fdb4c570de8516d05.svg";
export { ForwardRef as ReactComponent };